import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getHeaderTitle, HeaderShownContext } from "@react-navigation/elements";
import { StackActions } from "@react-navigation/native";
import * as React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import debounce from "../../utils/debounce";
import ModalPresentationContext from "../../utils/ModalPresentationContext";
import HeaderSegment from "./HeaderSegment";
export default /*#__PURE__*/ React.memo(function Header(param) {
    var back = param.back, layout = param.layout, progress = param.progress, options = param.options, route = param.route, navigation = param.navigation, styleInterpolator = param.styleInterpolator;
    var insets = useSafeAreaInsets();
    var previousTitle;
    // The label for the left back button shows the title of the previous screen
    // If a custom label is specified, we use it, otherwise use previous screen's title
    if (options.headerBackTitle !== undefined) {
        previousTitle = options.headerBackTitle;
    } else if (back) {
        previousTitle = back.title;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var goBack = React.useCallback(debounce(function() {
        if (navigation.isFocused() && navigation.canGoBack()) {
            navigation.dispatch(_object_spread_props(_object_spread({}, StackActions.pop()), {
                source: route.key
            }));
        }
    }, 50), [
        navigation,
        route.key
    ]);
    var isModal = React.useContext(ModalPresentationContext);
    var isParentHeaderShown = React.useContext(HeaderShownContext);
    var statusBarHeight = options.headerStatusBarHeight !== undefined ? options.headerStatusBarHeight : isModal || isParentHeaderShown ? 0 : insets.top;
    return /*#__PURE__*/ _jsx(HeaderSegment, _object_spread_props(_object_spread({}, options), {
        title: getHeaderTitle(options, route.name),
        progress: progress,
        layout: layout,
        modal: isModal,
        headerBackTitle: options.headerBackTitle !== undefined ? options.headerBackTitle : previousTitle,
        headerStatusBarHeight: statusBarHeight,
        onGoBack: back ? goBack : undefined,
        styleInterpolator: styleInterpolator
    }));
});
